import { Outlet } from 'react-router-dom'

import { AdminSidebar } from './AdminSidebar'

/**
 * Shell del panel /admin: sidebar fijo a la izquierda + main con Outlet.
 * El Suspense de las páginas lazy lo aporta `SuspenseShell` aguas arriba.
 */
export function AdminLayout() {
  return (
    <div className="mx-auto flex max-w-7xl gap-6 px-4 py-6 md:px-6 md:py-8">
      <AdminSidebar />
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  )
}
